import { Button, Container } from "@mui/material";
import styles from "./HomeVenue.module.scss";
import thumbnal from "Explore/Assets/homepage/homepage-venue.png";
import { IconPack } from "Explore/Config/Icons";

const HomeVenue = () => {
  return (
    <div className={styles["home-venue"]}>
      <Container maxWidth="lg" className={styles["home-venue__container"]}>
        <div className={styles["home-venue__left"]}>
          <div className={styles["home-venue__left--image__container"]}>
            <img
              className={styles["home-venue__left--image"]}
              src={thumbnal}
              alt="thumbnail"
            />
          </div>
        </div>
        <div className={styles["home-venue__right"]}>
          <p className={styles["home-venue__right--title"]}>Venues</p>
          <p className={styles["home-venue__right--description"]}>
            Do you want to find venues for your research topics? Do you want to
            connect with experts through the venues you are interested in?
          </p>
          <Button
            variant="contained"
            className={styles["home-venue__right--button"]}
            href="/explore/venue"
            endIcon={IconPack.arrow}
          >
            Browse Venues
          </Button>
        </div>
      </Container>
    </div>
  );
};

export default HomeVenue;
